// @flow
export { default } from './FakePartnerCard';



// WEBPACK FOOTER //
// ./src/components/common/FakePartnerCard/index.js